/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [
    MedicalTypeIds.SkinFaceToFace,
    MedicalTypeIds.Audiometry,
    MedicalTypeIds.RespiratorySensitiser,
    MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1,
    MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1,
    MedicalTypeIds.HAVSFaceToFace,
    MedicalTypeIds.IonisingRadiationFaceToFace,
    MedicalTypeIds.BiologicalMonitoring,
    MedicalTypeIds.OtherSurveillance,
    MedicalTypeIds.SafetyCriticalWorker,
    MedicalTypeIds.GroupOneDriving,
    MedicalTypeIds.GroupTwoDriving,
    MedicalTypeIds.WorkAtHeight,
    MedicalTypeIds.WorkingConfinedSpaces,
    MedicalTypeIds.WearingRPE,
    MedicalTypeIds.WearingBreathingApparatus,
    MedicalTypeIds.WorkingThermalEnvironment,
    MedicalTypeIds.DSE,
    MedicalTypeIds.Offshore,
    MedicalTypeIds.Airside,
    MedicalTypeIds.OtherFitnessToWork,
    MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
    MedicalTypeIds.AmzPitPupMedical,
    MedicalTypeIds.LAAWorker,
    MedicalTypeIds.SkinFaceToFaceLevel1,
    MedicalTypeIds.SkinAssessmentLevel2
];

export const bmiQuestion = {
    id: questionIds.Bmi,
    questionText: "BMI",
    medicalTypes
};

export const systolicTwoQuestion = {
    id: questionIds.SystolicBloodPressureTwo,
    questionText: "Systolic Blood Pressure (mmHG) Reading Two",
    medicalTypes
};

export const diastolicTwoQuestion = {
    id: questionIds.DiastolicBloodPressureTwo,
    questionText: "Diastolic Blood Pressure (mmHG) Reading Two",
    medicalTypes
};

export const systolicThreeQuestion = {
    id: questionIds.SystolicBloodPressureThree,
    questionText: "Systolic Blood Pressure (mmHG) Reading Three",
    medicalTypes
};

export const diastolicThreeQuestion = {
    id: questionIds.DiastolicBloodPressureThree,
    questionText: "Diastolic Blood Pressure (mmHG) Reading Three",
    medicalTypes
};

export const systolicFourQuestion = {
    id: questionIds.SystolicBloodPressureFour,
    questionText: "Systolic Blood Pressure (mmHG) Reading Four",
    medicalTypes
};

export const diastolicFourQuestion = {
    id: questionIds.DiastolicBloodPressureFour,
    questionText: "Diastolic Blood Pressure (mmHG) Reading Four",
    medicalTypes
};

export const systolicFiveQuestion = {
    id: questionIds.SystolicBloodPressureFive,
    questionText: "Systolic Blood Pressure (mmHG) Reading Five",
    medicalTypes
};

export const diastolicFiveQuestion = {
    id: questionIds.DiastolicBloodPressureFive,
    questionText: "Diastolic Blood Pressure (mmHG) Reading Five",
    medicalTypes
};

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const introQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.HealthUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.HealthUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.InformedOfMedicals,
        questionText: "I have informed the employee of the nature and purpose of medicals that are to be undertaken and they have agreed to undertake the appropriate medicals",
        medicalTypes
    },
    {
        id: questionIds.PrivacyStatementConfirmation,
        questionText: "I can confirm that I have provided the employee with access to the Optima Health Privacy Statement or details about where it can be found which clearly explains in detail how, where, how and when personal and health data will be processed",
        medicalTypes
    },
    {
        id: questionIds.InformationHeldSecurelyConfirmation,
        questionText: "I understand that my information will be held securely and if I wish to gain access to my medical information I can do so by requesting access in writing to Optima Health",
        medicalTypes
    },
    {
        id: questionIds.PhotographicIdSeen,
        questionText: "Photographic ID seen to confirm identify prior to medical taking place",
        medicalTypes
    },
    {
        id: questionIds.Height,
        questionText: "Height (cm)",
        medicalTypes
    },
    {
        id: questionIds.Weight,
        questionText: "Weight (KG)",
        medicalTypes
    },
    bmiQuestion,
    {
        id: questionIds.SystolicBloodPressure,
        questionText: "Systolic Blood Pressure (mmHG)",
        medicalTypes
    },
    {
        id: questionIds.DiastolicBloodPressure,
        questionText: "Diastolic Blood Pressure (mmHG)",
        medicalTypes
    },
    systolicTwoQuestion,
    diastolicTwoQuestion,
    systolicThreeQuestion,
    diastolicThreeQuestion,
    systolicFourQuestion,
    diastolicFourQuestion,
    systolicFiveQuestion,
    diastolicFiveQuestion,
    {
        id: questionIds.PulseRate,
        questionText: "Pulse Rate (bpm)",
        medicalTypes
    },
    {
        id: questionIds.Cholesterol,
        questionText: "Cholesterol (mmol/L)",
        medicalTypes
    },
    {
        id: questionIds.Psa,
        questionText: "PSA",
        medicalTypes
    },
    {
        id: questionIds.Whisper,
        questionText: "Has a Whisper Test been carried out?",
        medicalTypes
    },
    {
        id: questionIds.WhisperRightEarPassed,
        questionText: "Right Ear",
        medicalTypes
    },
    {
        id: questionIds.WhisperLeftEarPassed,
        questionText: "Left Ear",
        medicalTypes
    },
    {
        id: questionIds.DrugAlcoholTestUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.DrugAlcoholTestUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.InstantSubstanceAbuseTest,
        questionText: "Instant Substance Abuse Test",
        medicalTypes
    },
    {
        id: questionIds.InstantSubstanceAbuseTestResults,
        questionText: "Results",
        medicalTypes
    },
    {
        id: questionIds.LabSubstanceAbuseTest,
        questionText: "Lab Substance Abuse Test",
        medicalTypes
    },
    {
        id: questionIds.AlcoholBreathTest,
        questionText: "Alcohol Breath Test",
        medicalTypes
    },
    {
        id: questionIds.AlcoholBreathTestResults,
        questionText: "Results",
        medicalTypes
    },
    {
        id: questionIds.BloodSugar,
        questionText: "Blood Sugar (mmol/l)",
        medicalTypes
    },
    {
        id: questionIds.OnReviewOfQuestionnaireByEmployeeHaveTheyTickedYesToAny,
        questionText: "On review of the health questionnaire completed by the employee have they ticked yes to any questions?",
        medicalTypes
    },
    {
        id: questionIds.PleaseProvideFurtherInformationOnTheConditionSymptomsHighlighted,
        questionText: "Please provide further information on the condition/symptoms highlighted?",
        medicalTypes
    },
    {
        id: questionIds.PulseRhythm,
        questionText: "Pulse Rhythm",
        medicalTypes
    },
    {
        id: questionIds.GPSelfReferralLetterIssuedRegardingBloodPressureOrPulse,
        questionText: "GP self referral letter issued regarding blood pressure or pulse?",
        medicalTypes
    },
    {
        id: questionIds.BloodLeftEar,
        questionText: "Wax Left Ear",
        medicalTypes
    },
    {
        id: questionIds.BloodRightEar,
        questionText: "Wax Right Ear",
        medicalTypes
    },
    {
        id: questionIds.GPSelefReferralLetterIssuedRegardingWhisperTestResult,
        questionText: "GP self referral letter issued regarding Whisper Test result?",
        medicalTypes
    }
];
/* eslint-enable max-len */
